import React from 'react';
import RegistrationBegin from '../../components/registration/registrationbegin.component';
import registerUser from '../../api/registerUser';
import validateFields from '../../utils/validateFields';
import './registration-page.styles.css';
import Recaptcha, {
  executeRecaptcha,
} from '../../components/recaptcha/recaptcha.component';
import getModalContentFromRegistrationResponseStatusCode from './getModalContentFromRegistrationResponseStatusCode';
import formFieldFormatter from '../../utils/formFieldFormatter';
import { fireGoogleAnalyticsApiResponseEvent } from '../../utils/CommonUtil';

class RegistrationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: '',
      last: '',
      email: '',
      dateOfBirth: '',
      ssn: '',
      phone: '',
      countryCallingCode: '',
      showingSSN: false,
      formErrors: {
        first: undefined,
        last: undefined,
        dateOfBirth: undefined,
        email: undefined,
        ssn: undefined,
        phone: undefined,
        countryCallingCode: undefined,
      },
      submitting: false,
      modalContent: '',
      errorsExist: true,
    };
  }

  componentDidMount() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', () => {
      alert('Registration cannot be resubmitted!'); // eslint-disable-line no-alert
    });
  }

  handleChange = (event, data) => {
    const field = data.name === 'countryCallingCode' ? data.name : event.target.name;
    const value = data.name === 'countryCallingCode' ? data.value : event.target.value;
    this.setState({ [field]: formFieldFormatter(field, value) }, () => this.setState({
      formErrors: validateFields(field, this.state),
      errorsExist: !this.isFormValid(),
    }));
  };

  showSSN = () => this.setState({ showingSSN: !this.state.showingSSN });

  userRegistrationData = () => ({
    first: this.state.first,
    last: this.state.last,
    ssn: this.state.ssn,
    email: this.state.email,
    dateOfBirth: this.state.dateOfBirth,
    phone: `${this.state.countryCallingCode} ${this.state.phone}`,
  });

  toggleSubmitting = () => this.setState({ submitting: !this.state.submitting });

  handleSubmit = () => {
    executeRecaptcha();
  };

  handleRecaptchaComplete = (captchaResponse) => {
    const startTime = new Date();
    registerUser(this.userRegistrationData(), captchaResponse)
      .then((response) => {
        fireGoogleAnalyticsApiResponseEvent(
          'registerUser',
          new Date() - startTime,
        );
        this.show(response.status);
      })
      .catch((error) => {
        this.show(error.status);
        fireGoogleAnalyticsApiResponseEvent(
          'registerUser',
          new Date() - startTime,
        );
      })
      .finally(() => {
        this.toggleSubmitting();
      });
  };

  show = (status) => {
    this.setState({
      modalContent: getModalContentFromRegistrationResponseStatusCode(status),
    });
  };

  isFormValid = () => Object.values(this.state.formErrors).every((errorMsg) => errorMsg === null);

  render() {
    if (this.state.modalContent) {
      return <div>{this.state.modalContent}</div>;
    }
    return (
      <div className='center-contents'>
        <RegistrationBegin
          handleChange={this.handleChange}
          showSSN={this.showSSN}
          handleSubmit={this.handleSubmit}
          data={this.state}
          submitting={this.state.submitting}
        />
        <Recaptcha
          onChange={(recaptcha) => this.handleRecaptchaComplete(recaptcha)}
        />
      </div>
    );
  }
}

export default RegistrationPage;
